export default __webpack_public_path__ + "static/2267-7731a2972b35272ae14d0908a378baf5.gif";